import { all, takeLatest, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './action'
import caTxnActions from '../caTransactions/action'

import axiosMethod from '../../utilities/apiCaller'

const { cAPrivatePost } = axiosMethod

const initiatePayment = (id, value, token) => {
  return cAPrivatePost(`accounts/${id}/transactions`, value, token).then(response => {
    return response.data
  })
}

export function* initiateCryptoPayment(values) {
  const { value, token, id } = values
  try {
    const response = yield call(initiatePayment, id, value, token)
    yield put({
      type: actions.INITIATE_CRYPTO_PAYMENT_SUCCESS,
      value: response,
    })
    yield put({
      type: caTxnActions.UPDATE_SELECED_PAYMENT_TYPE,
      value: '',
    })
    notification.success({
      message: response.message,
    })
  } catch (err) {
    yield put({
      type: actions.INITIATE_CRYPTO_PAYMENT_FAILURE,
      payload: err,
    })
    notification.error({
      message: err.response.data.data.detail,
    })
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.INITIATE_CRYPTO_PAYMENT, initiateCryptoPayment)])
}
